export default "__VITE_ASSET__BD4vrz2B__"